import './App.css';
import Navbar from './Navbar/Navbar';
import HeroSection from './SectionsComponents/HeroSection';
import AboutSection from './SectionsComponents/AboutSection';
import WorkSection from './SectionsComponents/WorkSection';
import ContactSection from './SectionsComponents/ContactSection';
import Footer from './Footer/Footer';

function App() {
  return (
    <>
      <Navbar />
      <HeroSection />
      <AboutSection />
      <WorkSection />
      <ContactSection />
      <Footer />
    </>
  );
}

export default App;
